import { GoogleMap } from '@belong/ui';
import { Coordinates } from 'src/api/models';

type StreetViewProps = {
  coordinates: Coordinates;
};

const googleMapsApiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string;

export function Map({ coordinates }: StreetViewProps) {
  const { latitude, longitude } = coordinates;

  return (
    <GoogleMap
      bootstrapURLKeys={{
        key: googleMapsApiKey,
      }}
      zoom={11}
      center={{
        lat: Number(latitude),
        lng: Number(longitude),
      }}
    >
      <GoogleMap.IconMarker
        lat={Number(latitude)}
        lng={Number(longitude)}
        src={
          'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/accounts/map_home_pin_v2.svg'
        }
      />
    </GoogleMap>
  );
}
